import { useQuery } from "@tanstack/react-query";
import { getDashboardStats } from "../../api/bReviewsApi";

/**
 * Hook to fetch dashboard statistics for reviews
 * Uses the same filters as reviews list
 * @param {Object} params - Query parameters
 * @param {string} params.organisationId - Required organisation ID
 * @param {number[]} params.locationIds - Optional array of location IDs
 * @param {string[]} params.sentiments - Optional sentiment filters
 * @param {number[]} params.ratings - Optional rating filters
 * @param {boolean} params.replied - Optional reply status filter
 * @param {Date} params.startDate - Optional start date
 * @param {Date} params.endDate - Optional end date
 */
export const useGetDashboardStats = (params, enabled = true) => {
  return useQuery({
    queryKey: ["dashboard-stats", params],
    queryFn: () => getDashboardStats(params),
    enabled: !!params?.organisationId && enabled,
    staleTime: 1000 * 30, // 30 seconds
    refetchOnWindowFocus: true,
  });
};
